import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

import AnonymousBlankSlate from 'modules/surveys/components/Analytics/AnonymousBlankSlate'
import Head from 'modules/surveys/components/Analytics/ScoreResults/_Head'
import { useAnswers } from 'modules/surveys/components/Analytics/ScoreResults/hooks'
import { useAnalytics } from 'modules/surveys/pages/Show/hooks'
import type { Question } from 'modules/surveys/store/models/AnalyticResult'

interface Props {
  question: Question
}

const List = ({ question }: Props) => {
  const { analyticResult, form, cycle } = useAnalytics()
  const questionGroups = analyticResult.questionGroupsInCycle(cycle)
  const answers = useAnswers(question, questionGroups).get()
  const NOT_ANSWERED = '-'
  const isAnonymous = form.isAnonymous

  const filtered = answers.filter((val) => {
    return val.value
  })
  return (
    <Box>
      <Table overflowY="auto">
        <Head answers={answers} question={question} isTable />
        {isAnonymous && !filtered.length ? (
          <AnonymousBlankSlate />
        ) : (
          <Table.Body>
            {answers.map(({ key, value, respondentId }) => (
              <Table.Row key={key}>
                <Table.Cell>
                  <Box flexDirection="row" gap="s4">
                    {!form.isAnonymous && (
                      <Box width="s200" minWidth="s200">
                        <Text size="200" weight="semibold" color="grey800">
                          {(respondentId &&
                            (() => {
                              const u = users.get(respondentId)
                              return u
                                ? getFullDisplayName({
                                    firstName: u.attributes.first_name,
                                    lastName: u.attributes.last_name,
                                  })
                                : undefined
                            })()) ??
                            '-'}
                        </Text>
                      </Box>
                    )}
                    <Text size="200" color="grey1000" whiteSpace="breakSpaces">
                      {value || NOT_ANSWERED}
                    </Text>
                  </Box>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        )}
      </Table>
    </Box>
  )
}

export default observer(List)
